import { createFileRoute, useNavigate } from '@tanstack/react-router'
import PageHeader from '@/components/settings/PageHeader'
import IconImage from '@/components/settings/IconImage'
import SettingsMenuItem from '@/components/settings/SettingsMenuItem'
import { Mail } from 'lucide-react'
import { useState } from 'react'
import { DeleteAccountBottomSheet } from '@/components/settings/bottom-sheets/DeleteAccount'
import XIcon from '@/icons/x'
import { PendingDeletionBanner } from '@/components/settings/PendingDeletionBanner'
import { useCurrentUser } from '@/hooks/useCurrentUser'
import { useUserProfile } from '@/hooks/api/useUsers'

const legalMenuItems = [
    {
        icon: <IconImage name="file" alt="file" />,
        title: 'Terms and Conditions',
        description: 'View our terms and conditions',
        path: '/terms-and-conditions',
    },
    {
        icon: <IconImage name="file" alt="file" />,
        title: 'Privacy Policy',
        description: 'View our privacy policy',
        path: '/privacy-policy',
    },
    {
        icon: <IconImage name="file" alt="file" />,
        title: 'Terms of Use',
        description: 'View our terms of use',
        path: '/terms-of-use',
    },
]

export const Route = createFileRoute('/settings/contact-support')({
    component: RouteComponent,
})

function RouteComponent() {
    return <ContactSupportPage />
}

const ContactSupportPage = () => {
    const navigate = useNavigate()
    const [openDeleteAccount, setOpenDeleteAccount] = useState(false)
    const { user } = useCurrentUser()
    const { data: profile } = useUserProfile(user?.uid)

    return (
        <>
            <div className="min-h-dvh bg-white px-2 pb-14">
                <PageHeader title="Contact & Support" />

                <div className="flex flex-col gap-6 p-2">
                    {/* Pending Deletion Banner */}
                    {profile?.deletionRequest &&
                        profile.deletionRequest.status === 'PENDING' &&
                        user?.uid && (
                            <PendingDeletionBanner
                                deletionRequest={profile.deletionRequest}
                                userId={user.uid}
                            />
                        )}

                    {/* Legal Section */}
                    <div>
                        <h3 className="mb-3 text-lg font-semibold">Legal</h3>
                        <div className="flex flex-col gap-2">
                            {legalMenuItems.map((item) => (
                                <SettingsMenuItem
                                    key={item.title}
                                    icon={item.icon}
                                    title={item.title}
                                    description={item.description}
                                    onClick={() => navigate({ to: item.path })}
                                />
                            ))}
                        </div>
                    </div>

                    {/* Get in Touch Section */}
                    <div className="border-black-6 rounded-2xl border bg-white p-6">
                        <h3 className="mb-2 text-lg font-semibold">
                            Get in Touch
                        </h3>
                        <p className="mb-4 text-sm text-gray-600">
                            Need help? Our support team is here to assist you.
                        </p>
                        <div className="flex items-center gap-2">
                            <Mail className="h-5 w-5 text-gray-400" />
                            <a
                                href="mailto:support@wtf.style"
                                className="text-blue-600 hover:underline"
                            >
                                support@wtf.style
                            </a>
                        </div>
                    </div>

                    {/* Delete Account Section */}
                    <button
                        onClick={() => setOpenDeleteAccount(true)}
                        className="text-14 border-black-6 flex items-center justify-center gap-2 rounded-xl border px-4 py-3 font-normal text-[#FF3B30]"
                    >
                        <XIcon className="h-5 w-5" stroke="red" />
                        Delete Account
                    </button>
                </div>
            </div>

            <DeleteAccountBottomSheet
                open={openDeleteAccount}
                onClose={() => setOpenDeleteAccount(false)}
            />
        </>
    )
}
